import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, Inject, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource
import { ChonDoiTuongTHCPDataSource } from '../chon-doi-tuong-thcp-datasource/chon-doi-tuong-thcp.datasource';
//Service
import { ChonDoiTuongTHCPService } from '../chon-doi-tuong-thcp-service/chon-doi-tuong-thcp.service';
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from 'app/core/_base/crud';
import { environment } from 'environments/environment';
//Model
import { ChonDoiTuongTHCPModel } from '../chon-doi-tuong-thcp-model/chon-doi-tuong-thcp.model';
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { DungChungService } from 'app/views/pages/nfc/dung-chung/__services/dung-chung.service'
import { TokenStorage } from 'app/core/auth/_services/token-storage.service'
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';
import moment from 'moment';
@Component({
	selector: 'm-chon-doi-tuong-thcp-list',
	templateUrl: './chon-doi-tuong-thcp-list.component.html',
	styleUrls: ['../chon-doi-tuong-thcp.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class ChonDoiTuongTHCPListComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	// #filter group
	filterGroupDataChecked: any = {
	};
	filterText: any = {};
	tmpfilterText: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	isClearAll: boolean = false;
	haveFilter: boolean = false;
	saveNewNK: number[] = [];
	disableButtonFilter: any = {};
	// end filter group
	// Table fields
	dataSource: ChonDoiTuongTHCPDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: 'select',
			displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 2,
			name: 'STT',
			displayName: 'STT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'JobCode',
			displayName: 'Mã',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'JobName',
			displayName: 'Tên',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'JobType',
			displayName: 'Loại',
			alwaysChecked: false,
			isShow: true
		},
		
		
		
	];
	
	@ViewChild('sort1', { static: true }) sort: MatSort;
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;
	// Filter fields
	//filter on dropdown
	//end filter on dropdown
	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChonDoiTuongTHCPModel>(true, []);
	ChonDoiTuongTHCPsResult: ChonDoiTuongTHCPModel[] = [];
	tmpChonDoiTuongTHCPsResult: ChonDoiTuongTHCPModel[] = [];
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	previousIndex: number;
	ArrayIdNumber: number[] = [];
	fixedPoint = 2;
	PageCountTotalCurrent: number = 0;
	openDialog: boolean = false;
	//ROLES
	TAO = 265;
	LIST_ROLES_USER: [] = [];
	idcocaupb: any;
	userinfor: any = {};
	namenguoitao: string = '';

	arrTempChecked: ChonDoiTuongTHCPModel[] = [];
	isAllCheckBox: boolean = false;
	isChange: boolean = false;


	optionListJobType:any[]=[
		{
			name:'Phân xưởng',
			value:1
		},
		{
			name:'Sản phẩm',
			value:2
		},
		{
			name:'Quy trình xản xuất',
			value:3
		},
		{
			name:'Công đoạn',
			value:4
		},
	]

	jobType:number=0;

	constructor(
		private ChonDoiTuongTHCPsService: ChonDoiTuongTHCPService,
		public dialogRef: MatDialogRef<ChonDoiTuongTHCPListComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private DungChungService: DungChungService,
		private tokenStorage: TokenStorage,
	) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
	}
	/** LOAD DATA */
	ngOnInit() {
		//#region ***Filter***
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;
		this.tokenStorage.getFullName().subscribe(name => { this.namenguoitao = name })
		this.tokenStorage.getCoCauId().subscribe(cocau => { this.idcocaupb = cocau })
		this.tokenStorage.getUserInfo().subscribe(infor => { this.userinfor = infor });
		this.haveFilter = true;
		this.tmpfilterText = Object.assign({}, this.filterText);
		this.filterText['DeNghiTamUng_SoPhieu'] = "";
		this.filterText['NoiDung'] = "";
		this.filterText['SoTien'] = "";
		this.filterText['DeNghiTamUng_NgayDeNghi'] = "";
		this.filterText['DeNghiTamUng_HanThanhToan'] = "";
		this.jobType=this.data.jobType
		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {

			// 

			if (event.key == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.description) {
				this.back();
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.TIEPTUC.KeyCombine.keycode&&this.arrTempChecked.length>0) {
				this.tranferData();
			}

			
			this.changeDetect.detectChanges();
		});

		//#endregion ***Filter***
		this.showColumnsInTable();
		this.applySelectedColumns();
		// // If the ChonDoiTuongTHCP changes the sort order, reset back to the first page.
		
		/* Data load will be triggered in two cases:
		- when a pagination event occurs => this.paginator.page
		- when a sort event occurs => this.sort.sortChange
		**/
		merge(this.sort.sortChange)
			.pipe(
				tap(() => {
					this.loadChonDoiTuongTHCPsList();
				})
			)
			.subscribe();
		// // Set title to page breadCrumbs
		
		// Init DataSource
		this.dataSource = new ChonDoiTuongTHCPDataSource(this.ChonDoiTuongTHCPsService);
		let queryParams = new QueryParamsModel({});
		// // Read from URL itemId, for restore previous state
		this.route.queryParams.subscribe(params => {
			if (params.id) {
				queryParams = this.ChonDoiTuongTHCPsService.lastFilter$.getValue();
			}
			// First load
			this.loadChonDoiTuongTHCPsListDefaultPage();
		});
		this.dataSource.entitySubject.subscribe(res => {
			if (res) {
				this.PageCountTotalCurrent = res.length;
				this.ChonDoiTuongTHCPsResult = res
			}
			
			this.tmpChonDoiTuongTHCPsResult = []
			if (this.ChonDoiTuongTHCPsResult != null) {
				for (let i = 0; i < this.ChonDoiTuongTHCPsResult.length; i++) {
					let tmpElement = new ChonDoiTuongTHCPModel();
					tmpElement.copy(this.ChonDoiTuongTHCPsResult[i])
					this.tmpChonDoiTuongTHCPsResult.push(tmpElement);
				}
				
				this.ChonDoiTuongTHCPsResult.forEach(element => {
					
					for (let index = 0; index < this.data.arrSelected.length; index++) {
						const elementSelected = this.data.arrSelected[index];
						
						if(element.Job_Id==elementSelected.JobId&&elementSelected.isSelected){
							element.isSelected=true;
							this.selection.select(element);
							this.arrTempChecked.push(element);
						}
						
					}
					if(this.data.arrSelected.length==0){
						element.isSelected=false;
						
					}
					
				});
			}
		});
		
	}
	loadChonDoiTuongTHCPsList() {
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			0,
			0,
			this.filterGroupData
		);
		this.dataSource.loadChonDoiTuongTHCPs(queryParams);
	}
	//load list top page
	loadChonDoiTuongTHCPsListDefaultPage() {
		
		this.selection.clear();
		
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			0,
			0,
			this.filterGroupData
		);
		this.dataSource.loadChonDoiTuongTHCPs(queryParams);
	}
	// load list in font of page if item in current page is empty
	loadChonDoiTuongTHCPsListDeleteItemPage() {
		
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			0,
			0,
			this.filterGroupData
		);
		this.dataSource.loadChonDoiTuongTHCPs(queryParams);
	}
	/** FILTRATION */
	filterConfiguration(): any {
		const filter: any = {};

		//#filter
		filter.Jobtype=this.jobType;
		return filter;
	}
	/** ACTIONS */
	/** Delete */
	
	
	/** SELECTION */
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.ChonDoiTuongTHCPsResult.length;
		return numSelected === numRows;
	}
	/** Selects all rows if they are not all selected; otherwise clear selection. */
	
	masterToggle() {

		if (this.isAllCheckBox) {
			this.selection.clear();
			this.ChonDoiTuongTHCPsResult.forEach(row => {
				this.selection.select(row)
				let index = this.arrTempChecked.findIndex(x => x.Job_Id == row.Job_Id);
				if (index == -1) {
					this.arrTempChecked.push(row);
				}


			});



		} else {

			this.ChonDoiTuongTHCPsResult.forEach(row => {

				let index = this.arrTempChecked.findIndex(x => x.Job_Id == row.Job_Id && !x.isSelected);

				if (index > -1) {

					this.arrTempChecked.splice(index, 1);
				}


			});



			this.selection.clear();

		}



	}

	removeItemChecked(row:ChonDoiTuongTHCPModel){
		
		let index= this.arrTempChecked.findIndex(x=>x.Job_Id==row.Job_Id);
		if(index>-1){
			this.arrTempChecked.splice(index,1);
			this.selection.deselect(row);
		}else{
			this.arrTempChecked.push(row);
			this.selection.select(row);
		}
		
		this.changeDetectView();
	}

	checkItemChecked(row:ChonDoiTuongTHCPModel){
		
		
		return this.arrTempChecked.filter(x=>x.Job_Id==row.Job_Id).length>0?true:false
		
	}
	//Apply selected Column
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	/* UI */
	getItemStatusString(status: number = 0): string {
		switch (status) {
			case 0:
				return 'Chưa hoàn thành';
			case 1:
				return 'Đã hoàn thành';
		}
		return '';
	}
	getItemCssClassByStatus(status: number = 0): string {
		switch (status) {
			case 0:
				return 'metal';
			case 1:
				return 'success';
		}
		return '';
	}
	/**
	 * Show add ChonDoiTuongTHCP dialog
	 */
	ValidateChangeNumberEvent(event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		// var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	/* formatnumber for calculate */
	FormatCommaNumber(item: string) {
		return item.replace(/,/g, "");
	}
	/*end  formatnumber for calculate*/
	/*format datetime */
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	//#filter Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.changeDetect.detectChanges();
		}
	}
	filterHead(col) {
		if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
			this.filterGroupData[col] = [];
			this.filterGroupArray[col] = [];
			this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
				.filter(opt => opt.checked);
			this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
				.filter(opt => opt.checked).map(op => op.value);
		}
		this.filterText = Object.assign({}, this.tmpfilterText);
		if (this.filterText) {
			this.filterConfiguration();
		}

		if(this.tmpfilterText.tuDeNghiTamUng_NgayDeNghi||this.tmpfilterText.denDeNghiTamUng_NgayDeNghi||this.tmpfilterText.tuDeNghiTamUng_HanThanhToan||this.tmpfilterText.denDeNghiTamUng_HanThanhToan){
			this.isClearAll = true;
		}
		else{
			this.isClearAll = this.filterText[col]?true:false;
		}


		this.isClearAll = true;
		this.loadChonDoiTuongTHCPsList();
	}
	remove(item, col) {
		let _indexX = this.filterGroupDataCheckedFake[col].findIndex(x => x.value == item.value);
		let _indexY = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
		if (_indexX > -1) {
			this.filterGroupDataCheckedFake[col][_indexX].checked = false;
			this.filterGroupDataChecked[col][_indexY].checked = false;
			this.filterGroupData[col] = [];
			this.filterGroupArray[col] = [];
			this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
				.filter(opt => opt.checked);
			this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
				.filter(opt => opt.checked).map(op => op.value);
			if (this.filterGroupDataCheckedFake[col].filter(x => x.checked).length == 0) {
				this.tmpfilterText[col] = '';
				this.filterText[col] = '';
				for (let index = 0; index < this.filterGroupDataChecked[col].length; index++) {
					const element = this.filterGroupDataChecked[col][index];
					element.checked = false;
				}
				this.filterGroupDataCheckedFake[col] = [];
				this.filterGroupDataChecked[col].forEach(x => this.filterGroupDataCheckedFake[col].push(Object.assign({}, x)));
				this.disableButtonFilter[col] = true;
			}
			this.loadChonDoiTuongTHCPsList();
		}
	}
	removeText(col) {
		this.filterText[col] = "";
		this.tmpfilterText[col] = "";
		this.loadChonDoiTuongTHCPsList();
	}
	Clear() {
		
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
				}
			}
		}
		for (var key in this.filterGroupDataCheckedFake) {
			if (this.filterGroupDataCheckedFake.hasOwnProperty(key)) {
				if (this.filterGroupDataCheckedFake[key]) {
					this.filterGroupDataCheckedFake[key].forEach(element => {
						element.checked = false;
					});
				}
			}
		}
		this.filterGroupDataCheckedFake = {};
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		for (var key in this.tmpfilterText) {
			if (this.tmpfilterText.hasOwnProperty(key)) {
				this.tmpfilterText[key] = "";
			}
		}
		this.loadChonDoiTuongTHCPsList();
		this.isClearAll = false;
		this.changeDetect.detectChanges();
	}
	checkFilterHasValue(data, col) {
		let _count = 0;
		if (col == 'ALL' && data) {//check all column
			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					if (data[key]) {
						let _arrflt = data[key].filter(opt => opt.checked);
						_count += _arrflt ? _arrflt.length : 0;
					}
				}
			}
			let _text = "";
			for (var key in this.filterText) {
				if (this.filterText.hasOwnProperty(key)) {
					_text += this.filterText[key];
				}
			}
			if (_count > 0 || _text) {
				return true;
			}
		}
		else {//check in 1 column
			if (data && data[col]) {
				let _arrflt = data[col].filter(opt => opt.checked);
				_count += _arrflt ? _arrflt.length : 0;
			}
			if (_count > 0) {
				return true;
			}
		}
		return false;
	}
	/*----------------------- CSS HIỂN THỊ CHO TRẠNG THAI --------------------*/
	highlightNewestRecord(item: any) {
		// 
		var index = this.ChonDoiTuongTHCPsResult.indexOf(item);
		if (index > -1) {
			if (this.saveNewNK.indexOf(this.ChonDoiTuongTHCPsResult[index].Job_Id) > -1) {
				return true;
			}
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/
	checkDashboardRoute() {
		/* 
			Kiểm tra xem có phải đang ở dashboard không, nếu là trang dashboard thì không thực hiện
			các action trên component hiện tại.
		*/
		if (this.router.url === '/')
			return true;
		return false;
	}
	// filter on list status
	filterGroupWithTextFilter(columnName: string) {
		// 
		let search = this.tmpfilterText[columnName]
		let arraytemp = [];
		if (!search) {
			if (this.filterGroupDataCheckedFake[columnName].length > 0) {
				for (let index = 0; index < this.filterGroupDataChecked[columnName].length; index++) {
					const elementX = this.filterGroupDataChecked[columnName][index];
					for (let index = 0; index < this.filterGroupDataCheckedFake[columnName].length; index++) {
						const elementY = this.filterGroupDataCheckedFake[columnName][index];
						if (elementX.value == elementY.value && elementY.checked) {
							elementX.checked = true;
						} else if (!elementY.checked && elementX.value == elementY.value) {
							elementX.checked = elementY.checked;
						}
					}
				}
			}
			this.filterGroupDataCheckedFake[columnName] = [];
			this.filterGroupDataChecked[columnName].forEach(x => this.filterGroupDataCheckedFake[columnName].push(Object.assign({}, x)));
			
			this.disableButtonFilter[columnName] = this.checkStatuschecked(this.filterGroupDataCheckedFake[columnName]);
			this.changeDetect.detectChanges();
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filterGroupDataChecked[columnName].filter(x => x.name.toLowerCase().indexOf(search) > -1 ? arraytemp.push(Object.assign({}, x)) : x);
		if (arraytemp.length > 0) {
			
			for (let indexX = 0; indexX < this.filterGroupDataCheckedFake[columnName].length; indexX++) {
				const elementX = this.filterGroupDataCheckedFake[columnName][indexX];
				for (let indexY = 0; indexY < arraytemp.length; indexY++) {
					const elementY = arraytemp[indexY];
					if (elementX.checked && elementX.value == elementY.value) {
						elementY.checked = elementX.checked;
					} else if (!elementX.checked && elementX.value == elementY.value) {
						elementY.checked = elementX.checked;
					}
				}
			}
			this.filterGroupDataCheckedFake[columnName] = [];
			this.filterGroupDataCheckedFake[columnName] = arraytemp;
			for (let index = 0; index < this.filterGroupDataChecked[columnName].length; index++) {
				const elementX = this.filterGroupDataChecked[columnName][index];
				for (let index = 0; index < this.filterGroupDataCheckedFake[columnName].length; index++) {
					const elementY = this.filterGroupDataCheckedFake[columnName][index];
					if (elementX.value == elementY.value && elementY.checked) {
						elementX.checked = elementY.checked;
					} else if (!elementY.checked && elementX.value == elementY.value) {
						elementX.checked = elementY.checked;
					}
				}
			}
			this.changeDetect.detectChanges();
		} else {
			
			for (let index = 0; index < this.filterGroupDataChecked[columnName].length; index++) {
				const elementX = this.filterGroupDataChecked[columnName][index];
				for (let index = 0; index < this.filterGroupDataCheckedFake[columnName].length; index++) {
					const elementY = this.filterGroupDataCheckedFake[columnName][index];
					if (elementX.value == elementY.value && elementY.checked) {
						elementX.checked = elementY.checked;
					} else if (!elementY.checked && elementX.value == elementY.value) {
						elementX.checked = elementY.checked;
					}
				}
			}
			this.filterGroupDataCheckedFake[columnName] = [];
		}
		this.disableButtonFilter[columnName] = this.checkStatuschecked(this.filterGroupDataCheckedFake[columnName]);
		this.changeDetect.detectChanges();
	}
	//check status checkbox
	checkStatuschecked(data) {
		let countchecked = data.filter(x => x.checked);
		return countchecked.length > 0 ? false : true;
	}
	showClearAllButton() {
		let _count = 0;
		
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
		this.changeDetect.detectChanges();
	}
	disableDoneButton(col) {
		let countChecked = 0;
		if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
			for (var elementFake of this.filterGroupDataCheckedFake[col]) {
				if (elementFake.checked) {
					countChecked++;
				}
			}
		}
		if (countChecked > 0) {
			this.disableButtonFilter[col] = false;
		}
		else {
			this.disableButtonFilter[col] = true;
		}
	}
	/*----------------------- CÁC HÀM SỰ KIỆN FOCUS --------------------------*/
	forcusEvents() {
		this.openDialog = false;
		// if(this.focus != null && this.focus != undefined){
		// 	this.focus.first.nativeElement.focus();
		// }
		this.changeDetect.detectChanges();
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	back() {
		
		this.dialogRef.close(
			{

				IsChange: this.isChange,
				DataSelected: this.arrTempChecked
			});

	}

	tranferData(){
		this.isChange=true;
		this.back()
	}

	checkItemNotDisabled(){
		
		return this.arrTempChecked.filter(x=>!x.isSelected).length>0?false:true
	}

	convertJobTypeTilte(value:number){
		return this.optionListJobType.find(x=>x.value==value).name;
	}


}
